import { Injectable } from '@angular/core';
import { FeaturePermission } from '../../shared/services/api/permission.service';
import { StateService } from '../../shared/services/state/state.service';
import { PermissionStatusCode } from '../models/externe-apps';

@Injectable({
  providedIn: 'root',
})
export class MunicipalityManagementQueueStateService extends StateService<MunicipalityManagementQueueState> {
  public individualLinks$ = this.select((s) => s.individualLinks);
  public restrictions$ = this.select(() => this.state.restrictions);
  public restrictionsCustom$ = this.select(() => this.state.restrictions.filter((restriction) => restriction.permissionType === PermissionType.CUSTOM));
  public restrictionsBasicPremium$ = this.select(() =>
    this.state.restrictions.filter(
      (restriction) => restriction.permissionType === PermissionType.BASIC || restriction.permissionType === PermissionType.PREMIUM
    )
  );

  public hasQueue = () => this.state.individualLinks.length > 0 || this.state.restrictions.length > 0;
  public hasQueueRestrictions = () => this.state.restrictions.length > 0;

  constructor() {
    super(initialMunicipalityManagementQueueState);
  }

  public clear(): void {
    this.setState(initialMunicipalityManagementQueueState);
  }

  public clearIndividualLinks(): void {
    this.setState({ ...this.state, individualLinks: [] });
  }

  public clearRestrictions(): void {
    this.setState({ ...this.state, restrictions: [] });
  }

  public addLinktoQueue(featurePermission: FeaturePermission, externalLink: string, action: LinkAction): void {
    const filteredPermission = this.state.individualLinks.filter((value) => value.featurePermission.guid === featurePermission.guid);
    if (filteredPermission?.length > 0) {
      const individualLinks = this.state.individualLinks.map((value) => {
        if (value.featurePermission.guid === featurePermission.guid) {
          value.link = externalLink;
        }
        return value;
      });
      this.setState({ ...this.state, individualLinks: individualLinks });
    } else {
      this.setState({ ...this.state, individualLinks: [...this.state.individualLinks, { featurePermission, link: externalLink, action: action }] });
    }
  }

  public addStatustoQueue(statusCode: PermissionStatusCode, featurePermission: FeaturePermission, permissionType: PermissionType): void {
    const filteredPermission = this.state.restrictions.filter((value) => value.featurePermission.guid === featurePermission.guid);
    if (filteredPermission?.length > 0) {
      const restrictions = this.state.restrictions.map((value) => {
        if (value.featurePermission.guid === featurePermission.guid) {
          value.statusCode = statusCode;
        }
        return value;
      });
      this.setState({ ...this.state, restrictions: restrictions });
    } else {
      this.setState({
        ...this.state,
        restrictions: [...this.state.restrictions, { featurePermission, statusCode: statusCode, permissionType: permissionType }],
      });
    }
  }
}

export const initialMunicipalityManagementQueueState: MunicipalityManagementQueueState = {
  individualLinks: [],
  restrictions: [],
};

export interface MunicipalityManagementQueueState {
  individualLinks: { featurePermission: FeaturePermission; link: string; action: LinkAction }[];
  restrictions: { featurePermission: FeaturePermission; statusCode: PermissionStatusCode; permissionType: PermissionType }[];
}

export enum LinkAction {
  ADD,
  UPDATE,
  DELETE,
}

export enum RestrictionAction {
  TEASER = 'teaser',
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
}

export enum PermissionType {
  BASIC,
  PREMIUM,
  CUSTOM,
}
